import { render, staticRenderFns } from "./AmplifyAuth.vue?vue&type=template&id=e8dd9d3e&scoped=true&"
import script from "./AmplifyAuth.vue?vue&type=script&lang=js&"
export * from "./AmplifyAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dd9d3e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\camha\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8dd9d3e')) {
      api.createRecord('e8dd9d3e', component.options)
    } else {
      api.reload('e8dd9d3e', component.options)
    }
    module.hot.accept("./AmplifyAuth.vue?vue&type=template&id=e8dd9d3e&scoped=true&", function () {
      api.rerender('e8dd9d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/amplify/AmplifyAuth.vue"
export default component.exports